import 'bootstrap';
import Swiper from 'swiper'
import fancybox from '@fancyapps/fancybox'
import 'hamburgers/dist/hamburgers.css';

/*
    News boxes equal height
 */
if ( document.querySelectorAll('.news-box .news-box-top') ) {
    let news = document.querySelectorAll('.news-box .news-box-top');
    let height = Array.prototype.slice.call(news, 0).map(el => el.offsetHeight).sort().reverse()[0]
    news.forEach(el => el.style.height = height + "px")
}


//Fancybox

if ( document.querySelectorAll('.single-post .gallery a') ) {
    document.querySelectorAll('.single-post .gallery a').forEach( function(el) {
        el.setAttribute('data-fancybox', 'gallery')
    })
}

    $('.available-units table tr').click(function(e) {
        var href = $(this).find("a").attr("href");
        e.preventDefault();

        if(href) {
            $.fancybox.open([
                {
                    src  : href,
                    opts : {
                        // caption : 'First caption',
                        // thumb   : '1_s.jpg'
                    }
                }
            ], {
                loop : false
            });
        }
    });

/*
    Homepage swiper
 */

let homeSwiper = new Swiper('.home-swiper-container', {
    direction: 'vertical',
    loop: true,
    height: 820,
    effect: 'fade',
    watchOverflow: true,
    touchRatio: 0,
    allowTouchMove: false,
    autoplay: {
      delay: 3000
    },
    breakpoints: {

        1210: {
            slidesPerView: 1,
            noSwiping: true,
            allowSlidePrev: false,
            allowSlideNext: false
        },

    },

    pagination: {
        el: '.swiper-pagination',
    },
})

/*
    Notification slider
 */

let notificationSwiper = new Swiper('.notification-swiper-container', {
    loop: true,
    effect: 'slide',
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000
    }
})

/*
    Investments filters form handler / url builder
 */

if ( document.querySelector('.investment-listing-header') ) {
    document.querySelectorAll('.investment-listing-header select').forEach(el => {
        el.addEventListener('change', (e) => {
            let url = document.head.querySelector("[name~=current][content]").content + '/'
            document.querySelectorAll('.investment-listing-header select').forEach(s => {
                if ( s.value != '--' )
                    url += s.name + "/" + s.value + "/";
            })

            window.location.href = url;
        });
    })

    document.querySelector('.investment-listing-header input[name=search]').addEventListener('keyup', e => {
        if ( e.keyCode === 13 && e.target.value.length > 0 ) {
            let url = document.head.querySelector("[name~=current][content]").content + '/'
            window.location.href = url + 'search/' + encodeURI(e.target.value)
        }
    })

    document.querySelector('.investment-listing-header button').addEventListener('click', e => {
        e.preventDefault();
        let val = document.querySelector('.investment-listing-header input[name=search]').value;
        if ( val.length > 0 ) {
            let url = document.head.querySelector("[name~=current][content]").content + '/'
            window.location.href = url + 'search/' + encodeURI(val)
        }
    })
}

jQuery(document).ready(function($) {

    $('.hamburger').on('click', function () {
        $('body').toggleClass('nav-open');
        $(this).toggleClass('is-active');
    });

    if (window.innerWidth < 1210) {
        $('#header .menu .menu-item-has-children > a').on('click', function (e) {
            e.preventDefault();
            console.log('is-open');
            $(this).parent().toggleClass('is-open');
        });
    }

    $( ".elementor-text-editor table" ).wrap( "<div class='responsive-table'></div>" );

});

